import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import {
  AdministrationRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import { Dispatch, SetStateAction } from 'react';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';

interface RoleManagerGridToolbarProps {
  administrationRoles: string[];
  setOpenCreateRole: Dispatch<SetStateAction<boolean>>;
}

export default function RoleManagerGridToolbar({
  administrationRoles,
  setOpenCreateRole,
}: RoleManagerGridToolbarProps) {
  const queryClient = useQueryClient();
  return (
    <SharedToolbar
      noColumn
      primaryButtons={
        <CreateButton
          onClick={() => {
            setOpenCreateRole(true);
          }}
          disabled={
            !isAbleToSeeUIElement(
              administrationRoles,
              AdministrationRoles.CreateRole.value
            )
          }
          label="Add Role"
          tooltipLabel={
            !isAbleToSeeUIElement(
              administrationRoles,
              AdministrationRoles.CreateRole.value
            )
              ? `You are missing the ${AdministrationRoles.CreateRole.name} permission to perform this action.`
              : ''
          }
        />
      }
      secondaryButtons={
        <SharedIconButton
          variant="refresh"
          onClick={() => {
            queryClient.invalidateQueries({
              queryKey: [UserKeys.Roles],
            });
          }}
          tooltipLabel="Refresh"
        />
      }
    />
  );
}
